import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import Search from '@src/assets/icons/search.svg';

export const StyledInputSelectCountry = styled('div')`
  .dropdown {
    height: 308px;
    gap: 0px;
    border-radius: 12px;
    opacity: 0px;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }

  .dropdown__menu_items {
    overflow-y: scroll;
    max-height: calc(100% - 50px);

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }

  .dropdown__menu_search {
    background-color: #fff;
    position: sticky;
    outline: none;
    padding: 8px;
    border: none;
    min-width: 186px;
    width: ${(props) => (!props?.isModileWeb ? 186 : '100%')};
    overflow-x: hidden;
    top: 0;
    background-image: url(${Search});
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 12px 20px 12px 40px;
    border-bottom: 1px solid #3c3c4329;
    border-right: ${(props) =>
      !props?.isModileWeb ? '1px solid #3c3c4329' : 'none'};
  }
  .dropdown__menu_item {
    padding: 8px 16px 8px 16px;
    cursor: pointer;
    transition: all;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: rgba(28, 28, 30, 1);

    .country_name {
      color: #1c1c1e;
      flex: 1;
      line-height: 20px;
      font-weight: 510;
      font-size: 14px;
    }
    .country_flag {
      margin-right: 12px;
      display: flex;
      align-items: center;
      font-size: 16px;
    }
    .country_dialcode {
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      color: #1c1c1e7a;
    }
    .country_code {
      margin-right: 15px;
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      color: #1c1c1e;
    }
    .info_contry {
      display: flex;
      align-items: center;
      flex: 1;
      gap: 2px;
    }
    &:hover {
      background-color: rgba(30, 22, 78, 0.08);
    }
  }
  .selected {
    background-color: rgba(30, 22, 78, 0.08);
  }
`;
